import React, { useState } from "react";
import Styled, { css } from "styled-components";

import { ITheme, TBrowserAppType } from "../interface";
import { useTheme } from "../context/ThemeProvider";

import NavBar from "../components/molekul/NavBar";
import LandingMyInfo from "../components/molekul/landingMyInfo";
import LandingIkbalPhoto from "../components/molekul/landingIkbalPhoto";
import LandingSkillTool from "../components/molekul/landingSkillTool";
import MoreAboutMe from "../components/molekul/MoreAboutMe";
import MyExperience from "../components/molekul/MyExperience";
import MyTools from "../components/molekul/MyTools";
import BlogSection from "../components/molekul/Blogs";
import { screenSize } from "../constant";
const { maxWidth } = screenSize;

const Container = Styled.div<{
  $props: { theme: ITheme };
}>`${({ $props }) => {
  const { theme } = $props;
  return css`
    width: 100%;
    height: 100%;
    color: ${theme.colors.font};

    @property --fadeToColor {
      syntax: "<color>";
      initial-value: rgba(44, 62, 80, 1);
      inherits: false;
    }

    @property --primaryColor {
      syntax: "<color>";
      initial-value: rgba(4, 13, 18, 1);
      inherits: false;
    }
    transition: --fadeToColor 0.4s, --primaryColor 0.4s;
    background: linear-gradient(
      to bottom,
      var(--primaryColor) 0%,
      var(--primaryColor) 100vh,
      var(--primaryColor) 100vh,
      var(--fadeToColor) 100%
    );
    ${theme.name === "light"
      ? `
        --primaryColor: rgba(227,253,253,1);
        --fadeToColor: rgba(118,229,252,1);
      `
      : ""}
  `;
}}
`;

const DisplayContainer = Styled.div<{
  $props: { browserType: TBrowserAppType };
}>`
  
  ${({ $props }) => {
    const { browserType } = $props;
    return css`
      height: ${browserType === "chrome" ? 90 : 110}vh;
    `;
  }}
  display: grid;
  grid-template-columns: 10% 60% 30%;
  margin: 0px 10px 0px 10px;
  overflow: hidden;
  @media screen and (max-width: ${maxWidth.mediumTablet}) {
    grid-template-rows: 0fr;
    grid-template-columns: 50% 50%;
  }
  @media screen and (max-width: ${maxWidth.mediumPhoneV2}) {
    height: 80vh;
  }
`;

const ContentContainer = Styled.div`
  margin: 0 12vw;
`;

function Landing() {
  const { theme, browserType } = useTheme();
  const [showContent, setShowContent] = useState(true);
  const [showAboutMe, setShowAboutMe] = useState(false);
  const [showMyExperience, setShowMyExperience] = useState(false);
  const [showMyTools, setShowMyTools] = useState(false);
  window.addEventListener("scroll", () => {
    // console.log(window.scrollY);
    setShowContent(window.scrollY < 200);
    setShowAboutMe(window.scrollY > 150);
    setShowMyExperience(window.scrollY > 650);
    setShowMyTools(window.scrollY > 700);
  });

  return (
    <Container $props={{ theme }}>
      <NavBar />
      <svg
        style={{ visibility: "hidden", position: "absolute" }}
        width="0"
        height="0"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
      >
        <defs>
          <filter id="round">
            <feGaussianBlur in="SourceGraphic" stdDeviation="5" result="blur" />
            <feColorMatrix
              in="blur"
              mode="matrix"
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9"
              result="goo"
            />
            <feComposite in="SourceGraphic" in2="goo" operator="atop" />
          </filter>
        </defs>
      </svg>
      <DisplayContainer $props={{ browserType }}>
        <LandingMyInfo showContent={showContent} />
        {/* <div>LandingSkillTool</div> */}
        <LandingSkillTool showContent={showContent} />
        <LandingIkbalPhoto showContent={showContent} />
      </DisplayContainer>
      <ContentContainer>
        <MoreAboutMe showAboutMe={showAboutMe} />
        <MyExperience showMyExperience={showMyExperience} />
        <MyTools showMyTools={showMyTools} />
        <BlogSection />
      </ContentContainer>
    </Container>
  );
}

export default Landing;
